import { createUseStyles } from 'react-jss';


export default createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    fontWeight: '500',
    fontSize: '16px',
    color: '#102131',
  },

  switchContainer: {
    borderRadius: '16px',
    width: '48px',
    height: '32px',
    position: 'relative',
    boxShadow: 'none',
    transition: 'all 0.15s',

    '&:hover': {
      boxShadow: '0px 0px 12px 0px rgba(16, 33, 49, 0.2)',
    },
  },
  checkedContainer: {
    backgroundColor: 'green',
  },
  uncheckedContainer: {
    backgroundColor: 'red',
  },
  error: {
    backgroundColor: '#e8462b',
  },

  indicator: {
    width: '24px',
    height: '24px',
    background: '#FFFFFF',
    boxShadow: '-4px 0px 4px rgba(16, 33, 49, 0.04)',
    borderRadius: '50%',
    position: 'absolute',
    top: '4px',
    transition: 'left 0.15s',
  },
  checkedIndicator: {
    left: '20px',
  },
  uncheckedIndicator: {
    left: '4px',
  },

  disabled: {
    backgroundColor: '#DCDCDC',
    '&:hover': {
      boxShadow: 'none',
      cursor: 'not-allowed',
    },
  },
});
